import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  wrapperBox: ({ isDrawer }) => ({
    height: `${isDrawer ? theme.typography.pxToRem(300) : '100%'}`,
    width: '100%',
  }),
  container: {
    width: '100%',
    height: '100%',
  },
  inputSearch: {
    marginBottom: '2rem',
  },
  contentLists: ({ isDrawer }) => ({
    display: 'flex',
    height: `${isDrawer ? '100%' : 'calc(100% - 100px)'}`,
    flexWrap: `${isDrawer ? 'wrap' : 'nowrap'}`,
    flexDirection: 'row',
    gap: theme.spacing(5),
    alignItems: 'flex-start',
  }),

  labelList: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
  },
  boxList: {
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.darkGrey[15]}`,
    boxSizing: 'border-box',
    width: '100%',
    minWidth: theme.typography.pxToRem(390),
    height: 'calc(100% - 30px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    '@media screen and (max-height: 600px)': {
      height: theme.typography.pxToRem(250),
    },
  },
  itemText: {
    color: `${theme.palette.itemList.main} !important`,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(14),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineClamp: 2,
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  boxMessages: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
